import { SciTemplate } from 'enums';
import { SciDomain } from 'types';

export const getSciDomainOptions = (sciDomains: SciDomain[]) =>
  sciDomains.map(({ id, url, template, title }) => ({
    value: id,
    label: `${url} — ${title || template || SciTemplate.Default}`,
  }));
